import React from "react";
import { createRoot } from "react-dom/client";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import { Provider } from "react-redux";
import { store } from "./store";

import App from "./App";


const root = createRoot(document.getElementById("root"));
root.render(
   <GoogleReCaptchaProvider
      reCaptchaKey={"6LcsPZUkAAAAAC-nQ-_FIOCXeBhshxpX8wyTtZHp"}
      scriptProps={{
         async: false, // optional, default to false,
         defer: false, // optional, default to false
         appendTo: "body", // optional, default to "head", can be "head" or "body",
         nonce: undefined, // optional, default undefined
      }}
   // container={{
   //    // optional to render inside custom element
   //    parameters: {
   //       badge: "bottomright", // optional, default undefined
   //       theme: "dark", // optional, default undefined
   //    },
   // }}
   >
      <BrowserRouter>
         <Provider store={store}>
            <App />
            <Toaster
               toastOptions={{
                  style: {
                     background: "#f8f7f8",
                     fontSize: "1.4rem",
                  },
               }}
            />
         </Provider>
      </BrowserRouter>
   </GoogleReCaptchaProvider>
);
